export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10842.b5c4fe69.jpg";